import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ClassPage from './ClassPage';
import * as cartActions from '../../actions/cart';
import * as frameActions from '../../actions/frames';
import * as orderActions from '../../actions/orders';
import * as settingActions from '../../actions/settings';

const mapStateToProps = ({
  settings, product, order, frames: { frames, ...framesProps },
}) => ({
  frames,
  ...framesProps,
  ...settings,
  locale: window.bta.locale.substr(0, 2),
  isDemo: window.bta.isDemo,
  capacityType: product.data.capacity ? product.data.capacity.type : 0,
  durations: product.data.durations,
  minDate: product.data.mindate,
  maxDate: product.data.maxdate,
  variants: product.data.variants,
  locations: product.data.locations,
  resources: product.data.resources,
  productOptions: product.data.options,
  productTitle: product.data.title,
  maxAvailability: product.maxAvailability,
  totalPrice: order.totalPrice,
  quantity: order.quantity,
  totalQuantity: order.totalQuantity,
  selectedDate: order.date,
  available: order.available,
  orderVariants: order.variants,
  selectedLocation: order.selectedLocation,
  selectedResource: order.selectedResource,
  selectedVariant: order.variantSelected,
  additionalDetails: order.additionalDetails,
  selectedTimeslot: order.selectedTimeslot,
  onTrigger: window.xprops ? window.xprops.onTrigger : null,
  shopBeginningOfWeek: settings.defaultSetting.shop_beginning_of_week,
  shopDatepickerTimeInterval: settings.shop_datepicker_time_interval,
  shopDateFormat: settings.shop_date_format,
});

const mapDispatchToProps = (dispatch) => ({
  frameActions: bindActionCreators({ ...frameActions }, dispatch),
  orderActions: bindActionCreators({ ...orderActions }, dispatch),
  cartActions: bindActionCreators({ ...cartActions }, dispatch),
  settingActions: bindActionCreators({ ...settingActions }, dispatch),
});

const ClassWidgetPage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ClassPage);

export default ClassWidgetPage;
